/**
 * STS 工具类（无需登录版）
 * 核心逻辑：
 * 1. 无需登录态，直接调用后端接口获取 STS 凭证（内存+本地双重缓存）
 * 2. 自动检测凭证过期，过期前 30 秒自动刷新（无需前端判断刷新次数）
 * 3. 刷新失败自动重试（内置重试机制，无需前端干预）
 * 4. 提供清除缓存和资源销毁方法，避免内存泄漏
 */
// src/config/decrypt.js
// import request from '@/utils/request'
// import {
//     get
// } from '../config/http';
const crypto = require('crypto');
import axios from 'axios'
const {
	Buffer
} = require('buffer');
// 引入独立的密钥配置（关键！）
import {
	PRIVATE_KEY,
	ENCRYPT_CONFIG
} from './osskey';
// import config from "uview-ui/libs/config/config";
console.log('uedghufhvfhuvighjfibjhgfijb====',process.env.VUE_APP_BASE_API)
let baseURL=process.env.VUE_APP_BASE_API=='https://yshopapi.hpaopao.com'?'https://gateway.marathonbm.com':'https://marathon-test-gateway.hiracer.cn'
// ====================== 配置项（根据实际项目调整）======================
const CONFIG = {
	// baseURL: baseURL,//测试
	// baseURL: 'https://marathon-test-gateway.hiracer.cn',//正式
	// baseURL: 'http://192.168.0.165:61001',
	baseURL: 'https://gateway.marathonbm.com',
	// 后端提供的 STS 凭证接口（无需携带登录态）
	STS_API_URL: '/sys-token/aliYunSts',
	// 凭证提前刷新时间（30 秒，避免网络延迟导致过期）
	REFRESH_BEFORE_EXPIRE: 30 * 1000,
	// 本地缓存 key（用于存储 STS 凭证）
	STORAGE_KEY: 'sts_token_anonymous',
	// 刷新失败最大重试次数（无需前端关心，自动重试）
	MAX_RETRY_COUNT: 10,
	// 重试间隔时间（10 秒）
	RETRY_INTERVAL: 10 * 1000,
};

// ====================== 内部状态管理（避免重复请求/内存泄漏）======================
// 缓存 STS 凭证（内存 + 本地存储双重缓存）
let cachedStsToken = null;
// 标记是否正在请求凭证（防止并发重复请求）
let isFetching = false;
// 存储当前的刷新定时器（避免多个定时器冲突）
let refreshTimer = null;

// ====================== 核心工具函数 =======================
/**
 * 1. 初始化 STS 凭证（页面加载时调用，提前缓存）
 * 无需登录，直接初始化
 * @returns {Promise<Object>} STS 凭证
 */
export async function initStsToken() {
	console.log('从头开始初始化啦啦啦啦啦啦啦啦啦啦')
	try {
		console.log('【STS】开始初始化匿名凭证');
		sessionStorage.removeItem(CONFIG.STORAGE_KEY)
		// 先从本地存储加载缓存的凭证
		const storedToken = sessionStorage.getItem(CONFIG.STORAGE_KEY);
		if (storedToken) {
			cachedStsToken = JSON.parse(storedToken);
			// 检查缓存凭证是否有效，有效则直接返回并启动监听
			if (isTokenValid(cachedStsToken)) {
				console.log('【STS】使用本地缓存的有效匿名凭证');
				startExpireListener(cachedStsToken);
				return cachedStsToken;
			}
			console.log('【STS】本地缓存凭证已过期，将重新获取');
		}

		// 无有效缓存，调用后端接口获取新凭证（无需登录态）
		const newToken = await fetchStsTokenFromBackend();
		console.log('【STS】匿名凭证初始化成功');
		return newToken;
	} catch (error) {
		console.error('【STS】匿名凭证初始化失败：', error);
		throw error; // 抛出错误，让调用方感知
	}
}

/**
 * 2. 从后端接口获取 STS 凭证（内部使用，外部无需调用）
 * 无需携带登录态 Authorization 头
 * @returns {Promise<Object>} 新的 STS 凭证
 */
async function fetchStsTokenFromBackend() {
	// console.log('我要发请求',isFetching,sessionStorage.getItem('sts_token_anonymous'))
	// 防止并发重复请求：如果正在请求，等待请求完成后返回结果
	if (isFetching) {
		console.log('我已经发过请求了')
		return new Promise((resolve, reject) => {
			const checkInterval = setInterval(() => {
				if (!isFetching) {
					clearInterval(checkInterval);
					cachedStsToken ? resolve(cachedStsToken) : reject(new Error('匿名凭证获取失败'));
				}
			}, 100);
		});
	}

	isFetching = true;
	try {
		 
		// 调用后端接口（无需携带登录态 token）
		// const res = await request({
		// 	url: CONFIG.baseURL + CONFIG.STS_API_URL,
		// 	method: 'GET',
		// 	params: {
		// 		devices: 'H5'
		// 	},
		// 	header: {
		// 		'domain-scope': 'www.marathonbm.com',
		// 		'req-device-version': `H5[${navigator.userAgent}]|&#x53EF;&#x53D8;&#x7248;&#x672C;`,
		// 		'Content-Type': 'application/json',
		// 		// 移除登录态相关头，无需后端关联用户
		// 	},
		// });
        const res = await axios({
      baseURL: CONFIG.baseURL,
      url: CONFIG.STS_API_URL,
      method: 'GET',
      params: { devices: 'H5' },
      headers: {
        'domain-scope': 'www.marathonbm.com',
        'req-device-version': `H5[${navigator.userAgent}]|&#x53EF;&#x53D8;&#x7248;&#x672C;`,
        'Content-Type': 'application/json',
      },
      timeout: 10000,
    });
		console.log(res)
		// 后端返回错误处理
		if (res.data.code !== 200 || !res.data.data) {
			throw new Error(`后端返回错误：${res.message || '获取匿名 STS 凭证失败'}`);
		}
		//解密后端返回数据
		let data = rsaDecrypt(PRIVATE_KEY, res.data.data.secretData);
		data = JSON.parse(data)
		console.log(data)
		const stsToken = {
			...data,
			// expireDate: addHoursToTime(res.data.currentDate,1),
			currentDate: res.data.data.currentDate
		}
		console.log(stsToken)

		// 双重缓存：内存 + 本地存储
		cachedStsToken = stsToken;
		console.log('我更新了sts_token_anonymous的数据',stsToken)
		sessionStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(stsToken))
		// 启动过期监听（自动刷新逻辑）
		startExpireListener(stsToken);

		return stsToken;
	} finally {
		isFetching = false; // 无论成功失败，都重置请求状态
	}
}

/**
 * 3. 检查 STS 凭证是否有效
 * @param {Object} token - STS 凭证
 * @returns {boolean} 是否有效
 */
function isTokenValid(token) {
	console.log('查看本地sts数据详情',token)
	if (!token || !token.expireDate) return false;
	const currentDatestamp = new Date(token.currentDate).getTime();
	// 凭证过期时间（转成时间戳）
	const expireDatestamp = new Date(token.expireDate).getTime();
	// 当前时间 + 提前刷新时间 < 过期时间 → 凭证有效
	return currentDatestamp + CONFIG.REFRESH_BEFORE_EXPIRE < expireDatestamp;
}


/**
 * 5. 启动凭证过期监听（自动刷新核心逻辑）
 * 无需前端干预，到期前自动刷新，失败自动重试
 * @param {Object} token - STS 凭证
 */
function startExpireListener(token) {
	// 清除旧定时器（避免多个定时器冲突）
	if (refreshTimer) {
		clearTimeout(refreshTimer);
		refreshTimer = null;
	}

	// 计算刷新触发时间：过期时间 - 提前刷新时间
	const expireDatestamp = new Date(token.expireDate).getTime();
	const refreshTimestamp = expireDatestamp - CONFIG.REFRESH_BEFORE_EXPIRE;
	const delay = refreshTimestamp - new Date(token.currentDate).getTime();

	// 情况1：已过刷新时间，立即刷新
	if (delay <= 0) {
		console.log('【STS】匿名凭证已过刷新时间，立即刷新');
		fetchStsTokenFromBackend().catch(err => {
			console.error('【STS】匿名凭证立即刷新失败，启动重试', err);
			retryRefresh(CONFIG.MAX_RETRY_COUNT);
		});
		return;
	}

	// 情况2：未到刷新时间，设置定时器等待刷新
	console.log(`【STS】匿名凭证将在 ${Math.ceil(delay / 1000)} 秒后自动刷新`);
	refreshTimer = setTimeout(async () => {
		try {
			console.log('【STS】开始自动刷新匿名凭证');
			await fetchStsTokenFromBackend();
			console.log('【STS】匿名凭证自动刷新成功');
		} catch (error) {
			console.error('【STS】匿名凭证自动刷新失败：', error);
			// 刷新失败后，启动自动重试（无需前端处理）
			retryRefresh(CONFIG.MAX_RETRY_COUNT);
		}
	}, delay);
}

/**
 * 6. 刷新失败重试（内部自动处理，无需前端关心）
 * 最多重试 MAX_RETRY_COUNT 次，重试间隔 RETRY_INTERVAL
 * @param {number} remainingCount - 剩余重试次数
 */
function retryRefresh(remainingCount) {
	if (remainingCount <= 0) {
		console.error('【STS】匿名凭证刷新重试次数耗尽，请刷新页面');
		
		return;
	}

	console.log(`【STS】重试刷新匿名凭证（剩余次数：${remainingCount - 1}）`);
	refreshTimer = setTimeout(async () => {
		try {
			await fetchStsTokenFromBackend();
			console.log('【STS】重试刷新匿名凭证成功');
		} catch (error) {
			retryRefresh(remainingCount - 1);
		}
	}, CONFIG.RETRY_INTERVAL);
}

/**
 * 7. 获取当前有效的 STS 凭证（外部如需使用凭证时调用）
 * 无需前端判断有效性，直接调用即可获取有效凭证
 * @returns {Promise<Object>} 有效凭证（{accessKeyId, accessKeySecret, securityToken}）
 */
export async function getValidStsToken() {
	// 有有效缓存，直接返回核心字段
	if (cachedStsToken && isTokenValid(cachedStsToken)) {
		return {
			accessKeyId: cachedStsToken.accessKeyId,
			accessKeySecret: cachedStsToken.accessKeySecret,
			securityToken: cachedStsToken.securityToken,
		};
	}
	// 无有效缓存，重新获取并返回核心字段
	const newToken = await fetchStsTokenFromBackend();
	return {
		accessKeyId: newToken.accessKeyId,
		accessKeySecret: newToken.accessKeySecret,
		securityToken: newToken.securityToken,
	};
}

/**
 * 8. 清除 STS 凭证缓存（可选，如切换场景时调用）
 * 清除缓存 + 销毁定时器，避免内存泄漏
 */
export function clearStsCache() {
	console.log('【STS】清除匿名凭证缓存及相关资源');
	// 清除内存缓存
	cachedStsToken = null;
	// 清除本地存储缓存
	// uni.removeStorageSync(CONFIG.STORAGE_KEY);
	sessionStorage.removeItem(CONFIG.STORAGE_KEY)
	// 清除刷新定时器
	if (refreshTimer) {
		clearTimeout(refreshTimer);
		refreshTimer = null;
	}
	// 重置请求状态
	isFetching = false;
}

/**
 * 9. 确保 STS 凭证有效（业务接口调用前调用，比如上传文件前）
 * 简化外部使用：无需关心内部逻辑，调用即可保证凭证有效
 * @returns {Promise<void>}
 */
export async function ensureStsValid() {
	try {
		await getValidStsToken();
	} catch (error) {
		throw new Error(`STS 凭证无效：${error.message}`);
	}
}

/**
 * 10. 销毁 STS 管理器资源（页面卸载时调用）
 * 避免页面切换导致的定时器泄漏
 */
export function destroyStsManager() {
	console.log('【STS】销毁匿名凭证管理器资源');
	if (refreshTimer) {
		clearTimeout(refreshTimer);
		refreshTimer = null;
	}
	isFetching = false;
}

// 解密核心函数
// 核心解密函数（添加类型校验和转换）
const KEY_SIZE = 4096;
const MAX_ENCRYPT_4096_BIT = KEY_SIZE / 8 - 11; // 4096/8 -11 = 512 -11 = 501 字节
const MAX_DECRYPT_4096_BIT = KEY_SIZE / 8; // 4096/8 = 512 字节
function rsaDecrypt(privateKey, data) {
	try {
		// 1. 解码 Base64 私钥 → PKCS8 格式 Buffer（对应 Java Base64.decodeBase64(privateKey)）
		const privateKeyBuffer = Buffer.from(privateKey, 'base64');
		// 转换为 PEM 格式（Node.js crypto 模块要求私钥为 PEM 字符串）
		const privateKeyPEM = `-----BEGIN PRIVATE KEY-----
${privateKeyBuffer.toString('base64').match(/.{1,64}/g).join('\n')}
-----END PRIVATE KEY-----`;

		// 2. 解码 Base64 密文 → Buffer（对应 Java Base64.decodeBase64(data)）
		const encryptedBuffer = Buffer.from(data, 'base64');

		// 3. 初始化 RSA 解密配置（对齐 Java RSA/ECB/PKCS1Padding）
		const decryptOptions = {
			key: privateKeyPEM,
			padding: crypto.constants.RSA_PKCS1_PADDING, // 对应 Java PKCS1Padding
			// 注意：Java 中 ECB 模式在 Node.js 中无需显式配置（RSA 无 ECB 模式概念，仅填充方式匹配即可）
		};

		// 4. 分块解密（与 Java 分块逻辑完全一致）
		const dataSize = encryptedBuffer.length;
		let offSet = 0;
		const chunks = []; // 存储每块解密结果

		while (dataSize - offSet > 0) {
			// 计算当前分块大小（不超过最大分块和剩余数据长度）
			const chunkSize = Math.min(dataSize - offSet, MAX_DECRYPT_4096_BIT);
			// 截取当前分块（对应 Java byteData, offSet, chunkSize）
			const currentChunk = encryptedBuffer.slice(offSet, offSet + chunkSize);
			// 分块解密（对应 Java cipher.doFinal()）
			const decryptedChunk = crypto.privateDecrypt(decryptOptions, currentChunk);
			chunks.push(decryptedChunk);
			// 偏移量递增
			offSet += chunkSize;
		}

		// 5. 合并所有分块 → UTF-8 字符串（对应 Java ByteArrayOutputStream 合并）
		const decryptedBuffer = Buffer.concat(chunks);
		return decryptedBuffer.toString('utf8'); // 对应 Java StandardCharsets.UTF_8

	} catch (ex) {
		console.error('RSA 4096 位解密失败：', ex);
		return null;
	}
}

function addHoursToTime(timeStr, hours) {
  // 解析原始时间为 Date 对象
  const date = new Date(timeStr);
  
  // 容错处理：如果时间格式错误，返回原始字符串（可根据需求修改）
  if (isNaN(date.getTime())) {
    console.warn('时间格式错误，请传入 YYYY-MM-DD HH:mm:ss 格式');
    return timeStr;
  }
  
  // 累加小时数（自动处理跨天/跨月）
  date.setHours(date.getHours() + hours);
  // date.setMinutes(date.getMinutes() + 2);
  
  // 补0工具函数（简化重复逻辑）
  const padZero = (num) => num < 10 ? `0${num}` : num;
  
  // 格式化时间字符串
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1); // 月份0-11，需+1
  const day = padZero(date.getDate());
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());
  const second = padZero(date.getSeconds());
  
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}
// ====================== 自动初始化（可选，无需手动调用）======================
/**
 * 页面加载时自动初始化凭证（如果需要全局自动缓存）
 * 可根据需求注释掉，改为手动调用 initStsToken()
 */
// (async () => {
//   try {
//     await initStsToken();
//   } catch (err) {
//     console.warn('【STS】自动初始化失败，可在业务使用前手动初始化', err);
//   }
// })();